module.exports = __webpack_public_path__ + "img/mark-folder-back-favorite.00ae37a.svg";